module.exports = __webpack_public_path__ + "img/ic-eye-open.affc685d.svg";